/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleDraftInput } from './moduleDraftInput';
import type { ContentStudioMaterializeRequestConfig } from './contentStudioMaterializeRequestConfig';
import type { ContentStudioMaterializeRequestOriginalPrompt } from './contentStudioMaterializeRequestOriginalPrompt';

/**
 * Input: The approved module draft to be materialized in the DB.
 */
export interface ContentStudioMaterializeRequest {
  moduleDraft: ModuleDraftInput;
  config?: ContentStudioMaterializeRequestConfig;
  originalPrompt?: ContentStudioMaterializeRequestOriginalPrompt;
}
